import { useAuthDataContext } from "components/auth";
import { getRoomTemplateFileUrl } from "config/paths";

export default ({ id, contractId }) => {
  const { token } = useAuthDataContext();
  return getRoomTemplateFileUrl({ id, contractId, token });
};
